import DocumentsMain from './DocumentsMain'

export default {
  DocumentsMain,
}
